<template>
  <div class="interview-group" v-if="list.length > 0">
    <div class="interview-item" v-for="(item, index) in list" :key="index">
      <van-image round fit="cover" width="0.6rem" height="0.6rem" :src="item.header_img" />
      <div class="top">
        <span class="title">{{item.name}} | {{item.job}}</span>
      </div>
      <div class="desc">{{item.introduce}}</div>
    </div>
  </div>
  <no-data v-else></no-data>
</template>

<script>
import NoData from "@/components/NoData";

export default {
  name: "interview",
  components: {
    NoData
  },
  props: {
    list: {
      typeof: Array
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.interview-group {
  $mainC: #3a3a3a;
  $grayC: #999;
  $lightC: #378ede;
  $grayC1: #f3f3f3;

  .interview-item {
    border-bottom: 1px solid $grayC1;
    text-align: center;
    padding: 0.05rem 0;

    .top {
      .title {
        color: $mainC;
        font-size: 0.14rem;
        line-height: 0.2rem;
        padding: 0.05rem 0;
      }
    }

    .desc {
      padding: 0.1rem 0.15rem;
      font-size: 0.12rem;
      color: $grayC;
      line-height: 0.17rem;
    }
  }
}
</style>
